module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.89c3daac.webp";